import { connect } from 'react-redux';

import HeaderUi from './header.ui.jsx';

import {
  getPageTitle,
  getRenderAsMobile,
  getShouldShowHeader,
  getShouldShowSocialLinks,
  getShouldShowTitle,
  getSocialLinks,
  getSecondaryLogoData,
  getCurrentSubpage,
  getOrderedVisibleMainMenuItems,
  getVisibleSubmenuItemsBySubpageId,
  getHomeSubpage,
  getTranslationsIsEnabled,
  getTranslationsAppliedLanguages,
  getTranslationsCurrentLanguageIso,
  getTranslationsDefaultLanguageIso
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  shouldHideMainNavigation
} from 'zoomforth_codesbane_viewer/lib/navigation.js';

import {
  setTranslationsCurrentLanguageIso
} from 'zoomforth_codesbane_editor/action_creators/translations.js';

import { getRouter } from 'zoomforth_codesbane_viewer/lib/global_store.js';


const mapStateToProps = (state) => {
  const secondaryLogoData = getSecondaryLogoData(state);
  const socialLinks = getSocialLinks(state);
  const shouldShowSocialLinks = getShouldShowSocialLinks(state);
  const pageTitle = getPageTitle(state);
  const renderAsMobile = getRenderAsMobile(state);
  const shouldShowTitle = getShouldShowTitle(state);
  const shouldShowHeaderContents = getShouldShowHeader(state);

  const reallyShouldShowSocialLinks = shouldShowSocialLinks && !renderAsMobile && socialLinks.length > 0;

  const isTranslationsEnabled = getTranslationsIsEnabled(state);
  const appliedLanguages = getTranslationsAppliedLanguages(state);
  const currentLanguageIso = getTranslationsCurrentLanguageIso(state);
  const defaultLanguageIso = getTranslationsDefaultLanguageIso(state);

  const currentSubpage = getCurrentSubpage(state);
  const homeSubpage = getHomeSubpage(state);

  const menuItems = getOrderedVisibleMainMenuItems(state);
  const submenuItemsBySubpageId = getVisibleSubmenuItemsBySubpageId(state);
  const currentSubmenuItems = submenuItemsBySubpageId ?  submenuItemsBySubpageId[currentSubpage.id] : [];

  const hideDesktopNavigation = shouldHideMainNavigation(menuItems, currentSubmenuItems, homeSubpage.id);

  // we're in the legacy header so we know we need to if there is no nav
  const shouldShowLanguageSelectorInHeader = isTranslationsEnabled && hideDesktopNavigation;

  return {
    secondaryLogoData,
    socialLinks,
    reallyShouldShowSocialLinks,
    pageTitle,
    renderAsMobile,
    shouldShowTitle,
    shouldShowHeaderContents,
    shouldShowLanguageSelectorInHeader,
    appliedLanguages,
    currentLanguageIso,
    defaultLanguageIso
  };

};


const mapDispatchToProps = (dispatch) => (
  {
    onHeaderLogoClick: ()=> {
      getRouter().navigateHome({ trigger:true, replace:false });
    },
    onLanguageChange: (iso)=> {
      dispatch(setTranslationsCurrentLanguageIso(iso));
    }
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderUi);
